/**!
 * xman - xpopup.js 异步加载外壳 优先使用七巧板暴露的 window.SCXman
 *	
 * Copyright(c) 2017 Alibaba Group Holding Limited.
 * Authors:
 *   zhangsen.z
 */

'use strict';
require('./lazy-loader.js');
var xman = require('./lazy-xman.js'); 
var Popup = xman.Popup;
if(window.SCXman && window.SCXman.Popup && window.SCXman.scVersion > 0) {
    Popup = window.SCXman.Popup;
}

module.exports = Popup;